import { Routes } from '@angular/router';
import { TabTitleStrategyService } from '@sc/data-access-translation';
import {
  MobilePlanningCalendarContainer,
  MobilePlanningComponent,
  MobilePlanningDossierComponent,
  MobilePlanningFittersComponent,
  PlanningComponent,
} from './components';
import {
  PlanningContainer,
  PlanningContainerGuard,
} from './containers/planning';

export const routes: Routes = [
  {
    path: '',
    component: PlanningContainer,
    canActivate: [PlanningContainerGuard],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Planning',
    },
    children: [
      {
        path: '',
        component: PlanningComponent,
        data: {
          [TabTitleStrategyService.TAB_TITLE_KEY]:
            'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.Planning',
        },
      },
      {
        path: 'mobile',
        component: MobilePlanningComponent,
        data: {
          [TabTitleStrategyService.TAB_TITLE_KEY]:
            'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.MobilePlanning',
        },
        children: [
          {
            path: '',
            component: MobilePlanningFittersComponent,
            data: {
              [TabTitleStrategyService.TAB_TITLE_KEY]:
                'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.MobileFitters',
            },
          },
          {
            path: ':fitterId',
            component: MobilePlanningCalendarContainer,
            data: {
              [TabTitleStrategyService.TAB_TITLE_KEY]:
                'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.MobilePlanning',
            },
          },
          {
            path: 'dossier/:dossierId',
            component: MobilePlanningDossierComponent,
            data: {
              [TabTitleStrategyService.TAB_TITLE_KEY]:
                'GlobalApplicativeConstants.tabTitles.pageTitles.fitter.MobileDossier',
            },
          },
        ],
      },
    ],
  },
];
